<div class="overlay" (click)="onOverlayClicked($event)">
    <div class="dialog-shell" [class.dialog-shell--bare]="config?.data?.bareShell" (click)="onDialogClicked($event)">
      @if (!config?.data?.hideHeader) {
        <div class="dialog-shell__header">
          <div>
            @if (config?.data?.eyebrow) {
              <p class="dialog-shell__eyebrow">{{ config.data.eyebrow }}</p>
            }
            <h2 class="dialog-shell__title">{{ config?.data?.title || 'Dialog' }}</h2>
          </div>

          <button type="button" class="dialog-shell__close" (click)="closeDialog()" aria-label="Stäng dialog">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      }
        <ng-template appInsertion></ng-template>
      </div>
  </div>
